import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "1.875",
      height: "12.5289",
      x: "3.7487",
      y: "4.4611",
      stroke: "currentColor",
      "stroke-width": "0.833333"
    }, null, -1),
    _createElementVNode("rect", {
      width: "1.875",
      height: "12.5289",
      x: "7.28971",
      y: "4.4611",
      stroke: "currentColor",
      "stroke-width": "0.833333"
    }, null, -1),
    _createElementVNode("rect", {
      width: "1.875",
      height: "12.5289",
      x: "10.8327",
      y: "4.4611",
      stroke: "currentColor",
      "stroke-width": "0.833333"
    }, null, -1),
    _createElementVNode("rect", {
      width: "1.875",
      height: "12.5289",
      x: "14.3737",
      y: "4.4611",
      stroke: "currentColor",
      "stroke-width": "0.833333"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "four-columns"}) } }